import { useTranslation } from 'react-i18next';

export const useT = (...args) => useTranslation(...args);
